import { Link } from "react-router-dom";
import { Badge, Button, Card, Rating, Text } from "rothzerg-ui";
import { productPath } from "@/lib/routes";
import type { Product } from "@/types/catalog";
import { ColorSwatches } from "./ColorSwatches";
import { ProductBadge } from "./ProductBadge";

type ProductCardProps = {
  product: Product;
  showSwatches?: boolean;
};

export function ProductCard({ product, showSwatches = false }: ProductCardProps) {
  const savings =
    product.wasPrice && product.wasPrice > product.price
      ? product.wasPrice - product.price
      : null;

  return (
    <Card
      id={`product-card-${product.id}`}
      variant="ghost"
      className="kmart-product-card"
      style={{ padding: 0, overflow: "hidden" }}
    >
      <Link to={productPath(product.slug)}>
        <div style={{ position: "relative", background: "#f9f9f9", padding: "1rem" }}>
          {product.badges?.map((badge) => (
            <span
              key={badge.type}
              style={{ position: "absolute", top: 8, left: 8, zIndex: 1 }}
            >
              <ProductBadge badge={badge} />
            </span>
          ))}
          <img
            src={product.image}
            alt={product.title}
            style={{ width: "100%", aspectRatio: "1", objectFit: "contain" }}
          />
          {product.inStock && (
            <Button
              id={`product-add-${product.id}`}
              size="sm"
              style={{ position: "absolute", bottom: 8, left: 8 }}
              onClick={(e) => e.preventDefault()}
            >
              + Add
            </Button>
          )}
        </div>

        <div style={{ padding: "0.75rem" }}>
          <Text
            variant="caption"
            color="primary"
            style={{ display: "block", marginBottom: 4 }}
          >
            {product.sellerLabel ?? (product.seller === "kmart" ? "Kmart" : "Marketplace")}
          </Text>
          <Text variant="body" style={{ display: "block", marginBottom: 4 }}>
            {product.title}
          </Text>
          <Text variant="h4" weight="bold" style={{ display: "block" }}>
            ${product.price}
          </Text>
          {savings && (
            <Text variant="caption" color="destructive">
              save ${savings}
            </Text>
          )}
          {!product.inStock && (
            <Badge variant="secondary" size="sm">
              Out of stock
            </Badge>
          )}
          {product.rating != null && (
            <Rating value={product.rating} readOnly size="sm" showLabel />
          )}
          {showSwatches && product.colors && <ColorSwatches colors={product.colors} />}
        </div>
      </Link>
    </Card>
  );
}
